import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=2b968260&scoped=true&"
import script from "./popover.vue?vue&type=script&lang=ts&"
export * from "./popover.vue?vue&type=script&lang=ts&"
import style0 from "./popover.vue?vue&type=style&index=0&id=2b968260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b968260",
  null
  
)

export default component.exports